/**
 * Root-level Tracking Number Route
 * Redirects /$trackingNumber to /track/$trackingNumber for cleaner URLs
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$trackingNumber')({
  beforeLoad: ({ params }) => {
    const { trackingNumber } = params;
    const isValidTracking = /^[a-zA-Z0-9-]{5,50}$/.test(trackingNumber);

    if (isValidTracking) {
      throw redirect({
        to: '/track/$trackingNumber',
        params: { trackingNumber },
      });
    }

    throw redirect({
      to: '/',
    });
  },
});
